export const MOBILE_APP_TAP_THRESHOLD_PX = 8;

export function isTapGesture(
  dx: number,
  dy: number,
  threshold: number = MOBILE_APP_TAP_THRESHOLD_PX
): boolean {
  return Math.hypot(dx, dy) < threshold;
}
